import styled from "@emotion/styled";
import React, { useEffect, useRef, useState } from "react";

import { useTicketPackageList } from "@src/hooks/deungi/useTicketPackageList";
import { TicketPackageListResponseDto } from "@src/hooks/deungi/dto/PackageList.dto";
import { CORP_DEUNGI_POPUP_TYPE } from "./common/enum";
import corp_ads_ticket_ico from "@src/assets/deungi/corp_ads_ticket_ico.png";
import corp_ads_tickets_ico from "@src/assets/deungi/corp_ads_tickets_ico.png";
import { useFindOneUserSubsInfo } from "@src/hooks/user/userApi";
import { checkDevice } from "../deungi/common/utils";
import CorpDeungiTicketBox from "./CorpDeungiTicketBox";
import CorpDeungiPaymentInfoBox from "./CorpDeungiPaymentInfoBox";
import PackageCard from "../deungi/DeungiPackageCard";
import { PRODUCT_SALE_TYPE, TICKET_TYPE_STRING } from "../deungi/common/enum";
import CorpDeungiPopup from "./CorpDeungiPopup";
import { useGetCheckDeungiPayment } from "@src/hooks/payment/usePayment";
import { transferToNative } from "@src/lib/WebAppBridge";
import DeungiPurchaseCheckDialog from "../deungi/DeungiPurchaseCheckDialog";
import ConfirmModal from "../popup/ConfirmModal";
import { css } from "@emotion/react";

const CorpDeungiPackageListBox = () => {
    const deviceType = checkDevice();
    const [popupType, setPopupType] = useState<CORP_DEUNGI_POPUP_TYPE>(CORP_DEUNGI_POPUP_TYPE.OPEN);
    const [popupToggle, setPopupToggle] = useState(false);
    const [packageList, setPackageList] = useState({} as TicketPackageListResponseDto[]);
    const [openCheckSubs, setOpenCheckSubs] = useState<boolean>(false);
    const [openCheckDeungiPurchase, setOpenCheckDeungiPurchase] = useState<number>(0);

    const { data: checkDeunggiPayment, refetch } = useGetCheckDeungiPayment();

    //* 유저 구독 정보
    const { data: userSubscriptionInfo, refetch: refetchSubsInfo } = useFindOneUserSubsInfo();

    const getPackageList = async () => {
        const saleType = deviceType === "ios" ? PRODUCT_SALE_TYPE.IOS : PRODUCT_SALE_TYPE.DISPLAYED;
        const res = await useTicketPackageList(saleType);
        setPackageList(res.data.list);
    };

    const onPackageClickHandler = (data: TicketPackageListResponseDto) => {
        if (!data) return;
        if (data?.type === "corp_deungi_ticket") {
            refetch().then((res) => {
                if (res.isFetched) {
                    refetchSubsInfo().then((subs) => {
                        console.log(data.type);
                        if (subs.isFetched) {
                            if (data?.quantity !== 1 && (!subs.data?.subsNo || subs.data?.isFreeIssueSubs)) {
                                setOpenCheckDeungiPurchase(2);
                                return;
                            }
                            if (res.data === "disallow") {
                                setOpenCheckDeungiPurchase(1);
                                return;
                            }
                            if (deviceType !== "android") {
                                const ticketType = ["", ...Object.values(TICKET_TYPE_STRING)];
                                const params = JSON.stringify({
                                    productCode: data.code,
                                    productType: data.type,
                                    ticketType: ticketType.indexOf(data.type),
                                });
                                transferToNative(params, "payTicketInApp");
                            } else {
                                const params = JSON.stringify({
                                    pgType: "kcp.IP29N",
                                    product_name: data.name,
                                    product_code: data.code,
                                    discounted_price: data.discountPrice,
                                    type: "corp_deungi_ticket",
                                    searchText: "",
                                });
                                transferToNative(params, "payDeungiTicket");
                            }
                        }
                    });
                }
            });
        }
    };

    useEffect(() => {
        getPackageList();
        refetchSubsInfo();
    }, []);

    useEffect(() => {
        if (userSubscriptionInfo?.subsNo === 0 || userSubscriptionInfo?.isFreeIssueSubs) {
            setOpenCheckSubs(true);
        }
    }, [userSubscriptionInfo]);

    return (
        <>
            <Container>
                <CorpDeungiTicketBox />
                <PackageListBox>
                    <PackageCard
                        title="실시간 법인 등기열람권"
                        packages={
                            packageList.length > 0
                                ? packageList.filter((el) => el.type === TICKET_TYPE_STRING.CORP_DEUNGI_TICKET)
                                : []
                        }
                        singleTicketImage={corp_ads_ticket_ico}
                        multipleTicketsImage={corp_ads_tickets_ico}
                        active={true}
                        onTitleClick={() => {
                            setPopupType(CORP_DEUNGI_POPUP_TYPE.INFO);
                            setPopupToggle(true);
                        }}
                        onPackageClick={onPackageClickHandler}
                        onScroll={() => {}}
                    />
                    <CorpDeungiPaymentInfoBox />
                </PackageListBox>
                <CorpDeungiPopup type={popupType} toggle={popupToggle} setToggle={setPopupToggle} />
            </Container>
            {openCheckSubs && (
                <ConfirmModal
                    onConfirm={() => setOpenCheckSubs(false)}
                    resultMessage={
                        <div css={contentStyle}>
                            비구독 또는 무료 구독 회원의 경우,
                            <br />
                            ‘실시간 법인 등기열람권 1장’ 상품만 구매 가능하며 4장 이상은 구독회원에게만 제공됩니다.
                        </div>
                    }
                />
            )}
            <DeungiPurchaseCheckDialog open={openCheckDeungiPurchase} onCloseView={() => setOpenCheckDeungiPurchase(0)} />
        </>
    );
};

const PackageListBox = styled.div`
    height: fit-content;

    .packageBox {
        padding: 24px 14px 14px;

        &.active {
            background: #f6faff;
        }
        .titleBox {
            display: flex;
            align-items: center;
            margin-bottom: 14px;

            & > h3 {
                font-size: 18px;
                font-weight: 700;
            }
            & > img {
                width: 20px;
                height: 20px;
                margin-left: 8px;
            }
        }
        .items {
            display: flex;
            align-items: center;
            width: 100%;
            background: #fff;
            border: 1px solid #c9c9c9;
            border-radius: 14px;
            font-size: 16px;
            box-sizing: border-box;
            padding: 14px;
            margin-bottom: 14px;

            :active {
                border: 1px solid #2275ee;
                box-shadow: inset 0 0 0 1px #2275ee;
            }
            .radioItem {
                margin-right: 10px;

                &.hidden {
                    display: none;
                }
            }

            .imageBox {
                position: relative;
                margin: 0;

                min-width: 50px;
                height: 50px;

                border-radius: 8px;
                background-color: #f6faff;

                display: flex;
                align-items: center;
                justify-content: center;

                & > img {
                    width: 38px;
                    height: 38px;

                    &.multiple {
                        width: 50px;
                        height: 50px;
                    }
                }
            }
            & > div {
                display: flex;
                flex-direction: column;
                margin-left: 8px;

                & > span {
                    word-break: keep-all;
                    line-height: 1.1;
                }
                & > small {
                    margin-top: 7px;
                    color: #ff0000;
                }
            }
            & > .price {
                width: fit-content;
                min-width: 95px;
                height: 40px;
                background: #fff;
                border-radius: 8px;
                margin-left: auto;
                text-align: center;
                line-height: 40px;
                word-break: keep-all;
            }
        }
    }
`;

const Container = styled.div`
    height: 100%;
    overflow: scroll;
    background-color: white;
    .backDiv {
        width: 0;
        height: 75px;
    }
`;

const contentStyle = css`
    color: #0c002c;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
`;

export default CorpDeungiPackageListBox;
